import React, { lazy } from 'react';
import TitleToolTip from '../../TitleToolTip/index';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';

const layout = window?.$environment?.CURRENT_LAYOUT;
const ToolTip = lazy(() => import(`../../ToolTip`));
const Label = lazy(() => import(`globalcomponents/UI/Label/${layout}`));


export const titleToolTip = (title = '', info = '', className = 'subHeadTooltip', small = false, newUi = false) => {
  if (newUi) {
    return <TitleToolTip {...{ title, info, className, small }} />;
  }
  return (
    <div>
      <Label {...(small ? { className: className } : { variant: 'body1', className: `statsHeading ${className}` })}>
        {title}
        <ToolTip title={info} arrow placement="top">
          <InfoOutlinedIcon />
        </ToolTip>
      </Label>
    </div>
  );
};
